<template>
    <div class="userUpdate">
        <Button class="button reEnableButton"
                :button-type="'button'"
                :button-style="'buttonGhost'"
                :button-size="'default'"
                :isDisabled="!reEnableActivated"
                @on-click="onClick(STATUS.ACTIVE)">
                Re-enable
        </Button>

        <Button class="disableButton"
                :button-type="'button'"
                :button-style="'buttonGhost'"
                :button-size="'default'"
                :isDisabled="!disableActivated"
                @on-click="onClick(STATUS.DISABLED)">
                Disable
        </Button>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Button from '../shared/Button.vue';
import { 
    STATUS,
    MODAL_MESSAGE
} from '../shared/constants';

export default {
    components: { Button },
    data() {
        return {
            reEnableActivated: false,
            disableActivated: false,
            STATUS
        }
    },
    computed: mapGetters ([
        'selectedActiveUsers',
        'selectedDisabledUsers',
        'selectedUserIds'
    ]),
    mounted() {
        this.$root.$on("selectionChanged", () => this.updateButtons());
    },
    beforeDestroy() {
        this.$root.$off("selectionChanged", () => this.updateButtons());
    },
    methods: {
        ...mapActions([
            'showModal',
            'hideModal'
        ]),
        onClick(status) {
            this.showModal(MODAL_MESSAGE.CONFIRMATION(STATUS.ACTION[status], this.selectedUserIds));
        },
        updateButtons() {
            const active = this.selectedActiveUsers;
            const disabled = this.selectedDisabledUsers;
            if (disabled && !active) {
                this.reEnableActivated = true;
            }
            else if (active && !disabled) {
                this.disableActivated = true;
            }
            else {
                this.reEnableActivated = false;
                this.disableActivated = false;
                if (this.selectedUserIds.length > 0) {
                    this.showModal(MODAL_MESSAGE.MULTIPLE_STATUSES());
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.userUpdate {
    margin-left: auto;
}

.button {
    margin-right: 40px;
}

@media only screen and (max-width : 1123px ) {
    .userUpdate {
        margin-left: 0;
        margin-top: 10px;
    }
}

</style>
